export default __webpack_public_path__ + "static/media/robust-classification.1d641886.svg";